import { Link } from 'react-router-dom';
import Loading from '../../components/Loading';
import { minutes, shortDate, today } from '../../lib/dates';
import { thumbnailUrl } from '../../lib/youtube';
import { KIND, byDue, isOut } from '../../lib/kinds';
import { useClassroom } from '../../state/Classroom';

/** Everything open to work on (past-due ones are gone), soonest due first. */
export default function Work() {
  const { hydrated, assignments, progressFor } = useClassroom();
  if (!hydrated) return <Loading />;

  const t = today();
  const list = assignments.filter(a => isOut(a, t)).sort(byDue);

  return (
    <div>
      <h1>All my work</h1>
      <p className="sub">Open anything again to review it — every visit counts.</p>
      {list.length === 0 && <div className="notice">Nothing assigned right now.</div>}
      {list.length > 0 && (
        <section>
          <div className="list">
            {list.map(a => {
              const p = progressFor(a.id);
              return (
                <Link key={a.id} to={`/a/${a.id}`} className="item link">
                  <span className="kind">{a.kind === 'video'
                    ? <img src={thumbnailUrl(a.video_id!)} alt="" className="thumb" />
                    : <span className="thumb story-thumb">{KIND[a.kind].icon}</span>}</span>
                  <span className="grow">
                    <span className="term">{a.title}</span>
                    <span className="gloss small">
                      {KIND[a.kind].label}
                      {a.due_date && ` · due ${shortDate(a.due_date)}`}
                      {p && ` · ${minutes(p.seconds_spent)}`}
                    </span>
                  </span>
                  <span className={`status ${p?.completed_at ? 'done' : p ? 'started' : 'todo'}`}>
                    {p?.completed_at ? '✓ Done' : p ? 'Started' : 'To do'}
                  </span>
                </Link>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
}
